import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';

const testimonials = [
  {
    name: 'Ravi Sharma',
    role: 'Bullion Trader, Indore',
    text: 'I’ve been in the bullion trade for over 15 years, and this platform is by far the most efficient I’ve used. The rates update instantly, and the platform never lags during peak hours.',
    img: 'https://cdn.pixabay.com/photo/2022/02/16/16/46/jacket-7017158_1280.jpg',
  },
  {
    name: 'Aarushi Jain',
    role: 'Investor, Alirajpur',
    text: "As an investor, transparency and real-time data are important to me. This site provides both – along with excellent customer support and a secure trading experience.",
    img: 'https://cdn.pixabay.com/photo/2020/07/30/10/57/indian-woman-5450102_1280.jpg',
  },
  {
    name: 'Daksh Soni',
    role: 'Jeweller',
    text: "Earlier, I had to rely on calls to get rates. Now I can track everything live and place orders within seconds. It's reliable, professional, and saves me hours every week.",
    img: 'https://codestatiion.netlify.app/images/me.jpg'
  },
  {
    name: 'Karan Soni',
    role: 'Wholesaler,Indore',
    text: 'Using this platform has completely streamlined my gold and silver purchasing. The live rates are always accurate and the booking process is smooth. I trust it for all my daily trades.',
    img: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg'
  },
];

// Custom arrow components
const Arrow = styled.div`
  z-index: 1;
  display: block;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  padding: 10px;
  position: absolute;
  top: 40%;
  cursor: pointer;
  ${(props) => props.left ? 'left: -30px;' : 'right: -30px;'}
`;

const NextArrow = (props) => (
  <Arrow onClick={props.onClick}>›</Arrow>
);

const PrevArrow = (props) => (
  <Arrow left onClick={props.onClick}>‹</Arrow>
);

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <SliderWrapper>
      <Slider {...settings}>
        {testimonials.map((item, index) => (
          <Card key={index}>
            <ImageWrapper>
              <Image src={item.img} alt={item.name} />
            </ImageWrapper>
            <Name>{item.name}</Name>
            <Role>{item.role}</Role>
            <Text>"{item.text}"</Text>
          </Card>
        ))}
      </Slider>
    </SliderWrapper>
  );
};

export default TestimonialSlider;

// Styled Components
const SliderWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
  position: relative;
`;

const Card = styled.div`
  text-align: center;
  padding: 20px;
  background: #393535;
  color: #f1f1f1;
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.4);
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid gold;
`;

const Name = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
`;

const Role = styled.p`
  font-size: 0.95rem;
  color: #aaa;
  margin-top: 4px;
`;

const Text = styled.p`
  font-size: 1rem;
  margin-top: 10px;
  line-height: 1.6;
  font-style: italic;
`;



